import React, {useEffect, useRef, useState} from 'react';
import '../../css/widgets.css';
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import {Avatar} from 'primereact/avatar';
import axios from "axios";
import {InputTextarea} from 'primereact/inputtextarea';
import {Tag} from "primereact/tag";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataView} from "primereact/dataview";
import {Card} from "primereact/card";
import {ScrollPanel} from "primereact/scrollpanel";
import {TabPanel, TabView} from "primereact/tabview";
import {Paginator} from "primereact/paginator";

const MessageList = (props) => {
    const toast = useRef(null);
    const prevYZekaTypeRef = useRef();
    const scroolRef = useRef(null);
    const [dialog, setDialog] = useState(false);
    const [loadingState, setLoadingState] = useState(true)
    const [typeList, setTypeList] = useState([]);
    const [codes, setCodes] = useState([]);
    const [message, setMessage] = useState('');
    const [user_id, setuser_id] = useState(null);
    const [chat_id_list, setChatIdList] = useState('');
    const [getmessages, setMessages] = useState([]);
    const [onlyMessages, setOnlyMessages] = useState([]);
    const [messageContext, setMessageContext] = useState('');
    const [receiverName, setReceiverName] = useState('');
    const [chatID, setChatID] = useState(null);
    const [dat, setChat] = useState([]);
    const [cipDeleteDialog, setCipDeleteDialog] = useState(false);
    const [introId, setIntroId] = useState(null);
    const [unreadMessageCount, setUnreadMessageCount] = useState(null);
    const [layoutDetail, setLayoutDetail] = useState('gridDetail');
    const [sortOrder, setSortOrder] = useState(null);
    const [sortField, setSortField] = useState(null);
    const [chatContent, setChatContent] = useState(null);
    const local_user_name = localStorage.getItem('user_username');
    const [getMessage, setGetMessage] = useState(false);
    const [msgId, setMsgId] = useState(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [page, setPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalOnlyRecords, setTotalOnlyRecords] = useState(0);
    const [first, setFirst] = useState(0);


    let all_table_header_tabpanel = (

        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>Tümü ({totalRecords})</b></h6>

        </div>);

    let table_header_tabpanel = (

        <div className="p-mt-1">
            <h6 className="p-mb-2"><b> Benim Mesajlarım ({totalOnlyRecords}) </b></h6>

        </div>);


    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error', summary: message, life: 3000
        });
    }

    let interval;
    useEffect(() => {
        messages(page);
        onlymessages();
        inputMessageRecipientList();

        if (msgId !== prevYZekaTypeRef.current) {
            interval = setInterval(() => {
                messageView();
            }, 700);
        }
        prevYZekaTypeRef.current = msgId
        return () => {
            clearInterval(interval);
        };
    }, [msgId]);

    const submit = () => {
        const user_data = {
            'message': message,
            'messageContext': messageContext,
            'receiverName': receiverName,
        };
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(user_data);
            fetch("/api/messageProcess/", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data.result) {
                            messages(page);
                            onlymessages();
                            showSuccess(data.message);
                            setMessage('')
                            setMessageContext('')
                            setReceiverName('')
                        } else {
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401 || res.status === 403) {
                        setLoadingState(false);
                        throw res.data;
                    }
                })
            setDialog(false)
        }
    }

    const onBasicPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
        messages(event.page);
    }

    const messageSubmit = (recipient_name) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/messageProcess/" + recipient_name + "/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data) {
                            // setDialog(false)
                            setTypeList(data.result)
                            setCodes(data.code_list)
                        } else {
                            // setDialog(false)
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401 || res.status === 403) {
                        setLoadingState(false);
                        setDialog(false)
                        throw res.data;
                    }
                })
        }
    }

    const messageMySubmit = (dat) => {
        var user_data = {}
        //alıcı
        if (dat['repley_list'].length === 0) {
            if (dat.msg_to === dat.user_id) {
                user_data = {
                    'message': message,
                    'messageContext': messageContext,
                    'receiverName': dat.msg_send,
                    'msg_id': dat.msg_id,
                    'mtyp_id': dat.mtyp_id,
                    'msg_to': dat.msg_from,
                }
            } else {
                user_data = {
                    'message': message,
                    'messageContext': messageContext,
                    'receiverName': dat.msg_send,
                    'msg_id': dat.msg_id,
                    'mtyp_id': dat.mtyp_id,
                    'msg_to': dat.msg_to,
                }
            }
        } else {
            // for (var i = 0; i < dat['repley_list'].length; i++) {
            if (parseInt(user_id) === parseInt(dat['repley_list'].at(-1).user_id_from)) {
                var msg_to = dat['repley_list'].at(-1).msg_to
                var msg_from = user_id
                user_data = {
                    'message': message,
                    'messageContext': messageContext,
                    'receiverName': receiverName,
                    'msg_id': dat['repley_list'].at(-1).msg_id,
                    'mtyp_id': dat['repley_list'].at(-1).mtyp_id,
                    'msg_to': dat['repley_list'].at(-1).msg_to,
                }

            } else if (parseInt(user_id) === parseInt(dat.user_id_from)) {
                user_data = {
                    'message': message,
                    'messageContext': messageContext,
                    'receiverName': receiverName,
                    'msg_id': dat.msg_id,
                    'mtyp_id': dat.mtyp_id,
                    'msg_to': dat.msg_to,
                }
            } else {
                user_data = {
                    'message': message,
                    'messageContext': messageContext,
                    'receiverName': receiverName,
                    'msg_id': dat.msg_id,
                    'mtyp_id': dat.mtyp_id,
                    'msg_to': dat.msg_from,
                }
            }
            // }
        }
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(user_data);
            fetch("/api/messageMyProcess/", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data.result) {
                            // showSuccess(data.message);
                            messages(page);
                            onlymessages();
                            messageView();
                            setMessage('')
                            setMessageContext('')
                            setReceiverName('')
                        } else {
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401 || res.status === 403) {
                        setLoadingState(false);
                        throw res.data;
                    }
                })
            setDialog(false)
        }
    }

    const messageView = () => {
        if (msgId) {
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                fetch("/api/messageView/" + msgId + "/", {headers, method: "GET"})
                    .then(res => {
                        if (res.status < 500) {
                            setLoadingState(false)
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            const data = res.data;
                            if (data) {
                                setChatContent(data.result[0])
                                setChatIdList(data.result[0].chat_id_list)
                                showSuccess(data.message);
                                setGetMessage(true);
                                // setuser_id(data.user_id)
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 403) {
                            showError(res.data.detail);
                            setLoadingState(false);
                            throw res.data;
                        } else if (res.status === 401) {
                            props.loadUser();
                        }
                    })
            }
        }
    }

    const messages = (page) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            axios.get('/api/messages/' + page + "/", {"headers": headers})
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data) {
                            setMessages(data.result)
                            setuser_id(data.user_id)
                            setTotalRecords(res.data.total_records);
                            localStorage.setItem("messageCount", data.unreadMessageCount)
                            setUnreadMessageCount(data.unreadMessageCount)
                            messageEdit(user_id, data.result);
                        } else {
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
        if (chatID !== null) {
            for (let i = 0; i < getmessages.length; i++) {
                if (chatID === getmessages[i].msg_id) {
                    setChat(getmessages[i])
                }
            }
        }
    }


    const onlymessages = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            axios.get('/api/only_messages/', {"headers": headers})
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data) {
                            setOnlyMessages(data.result)
                            setuser_id(data.user_id)
                            setTotalOnlyRecords(res.data.totalOnlyRecords);
                            localStorage.setItem("messageCount", data.unreadMessageCount)
                            setUnreadMessageCount(data.unreadMessageCount)
                            messageEdit(user_id, data.result);
                        } else {
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
        if (chatID !== null) {
            for (let i = 0; i < onlyMessages.length; i++) {
                if (chatID === onlyMessages[i].msg_id) {
                    setChat(onlyMessages[i])
                }
            }
        }
    }

    const renderFooter = () => {
        return (
            <div>
                <Button label="Hayır" icon="pi pi-times" onClick={() => setCipDeleteDialog(false)}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={deleteMessages}
                        autoFocus/>
            </div>
        );
    }

    const deleteRow = () => {
        setCipDeleteDialog(true)

    }

    const sendMessageHide = () => {
        setDialog(false)
        setCodes([])
        setReceiverName('')
    }

    const deleteMessages = () => {
        const user_data = {
            'chat_id_list': chat_id_list,
            'msg_id': msgId
        };
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(user_data);
            fetch("/api/message_delete/", {headers, method: "DELETE", body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                        if (res.status === 200) {
                            setLoadingState(false)
                            const data = res.data;
                            console.log("--------------,", data)
                            if (data.result) {
                                setCipDeleteDialog(false)
                                messages(page);
                                onlymessages();
                                messageView();
                                setIntroId(null)
                                setDeleteSuccess(true);
                            } else {
                                showError(data.message);
                            }
                        } else if (res.status === 401 || res.status === 403) {
                            setLoadingState(false);
                            throw res.data;
                        }
                    }
                )
        }
    }

    const messageEdit = (user_id) => {
        if (chatContent) {
            var ownUserID = chatContent.msg_to // alıcı
            var fromUserID = chatContent.msg_from // gönderici
            //mychat
            return (
                <div style={{display: deleteSuccess ? 'none' : 'block'}}>
                    <div className="table-header p-grid"
                         style={{
                             backgroundColor: '#dbdbdb',
                             justifyContent: 'center',
                             borderRadius: '13px',
                             // width: '100%',
                             overflowX: "hidden",
                             marginLeft: '14px',
                             marginRight: '26px'
                         }}>

                        <div className="p-col-12 p-lg-1" align='center'>
                            {chatContent.msg_send === local_user_name ?
                                <Avatar image={chatContent.pers_to_photo} size="xlarge"
                                        shape="circle"/> :

                                <Avatar image={chatContent.pers_from_photo} size="xlarge"
                                        shape="circle"/>}
                        </div>

                        <div className="p-col-12 p-lg-8" align='left' style={{margin: 'auto', minHeight: '100%'}}>
                            {chatContent.msg_send === local_user_name ? <h3>{chatContent.msg_receive}</h3> :
                                <h3>{chatContent.msg_send}</h3>}
                        </div>

                        <div className="p-col-12 p-lg-2" align='right' style={{margin: 'auto'}}>
                            <Button
                                icon="pi pi-arrow-down"
                                className="p-button-rounded p-button-info p-button-text"
                                onClick={() => scrollbottom()}
                                tooltipOptions={{
                                    position: 'bottom',
                                    mouseTrack: true,
                                    mouseTrackTop: 15,
                                }}/>

                            <Button
                                icon="pi pi-trash"
                                className="p-button-rounded p-button-info p-button-text"
                                aria-label="Cancel"
                                onClick={() => deleteRow()}
                                tooltip="Mesajı Sil"
                                tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                        </div>
                    </div>

                    <ScrollPanel
                        style={{height: '500px', overflowX: "hidden"}}>

                        <div style={{
                            backgroundColor: '#ececec',
                            marginRight: '20px',
                            marginLeft: '20px'
                        }}>

                            {chatContent.repley_list.length === 0 ?
                                <div className="widget-chat">
                                    {chatContent.msg_from === chatContent.user_id ? <ul>
                                        <li className="message-own" key={chatContent.msg_id}>
                                            {/*<img src={chatContent.pers_to_photo} alt="diamond-layout"*/}
                                            {/*     title={chatContent.alıcı}/>*/}
                                            <div>
                                                {chatContent.msg_text}
                                                <p align="right"
                                                   style={{
                                                       marginTop: '3px', fontSize: '10px'
                                                   }}>{chatContent.msg_createtime}</p>
                                            </div>
                                        </li>
                                    </ul> : <ul>
                                        <li className="message-from" key={chatContent.msg_id}>
                                            {/*<img src={chatContent.pers_from_photo} alt="diamond-layout"*/}
                                            {/*     title={chatContent.gönderici}/>*/}
                                            <div>
                                                {chatContent.msg_text}
                                                <p align="right"
                                                   style={{
                                                       marginTop: '3px', fontSize: '10px'
                                                   }}>{chatContent.msg_createtime}</p>
                                            </div>
                                        </li>
                                    </ul>}
                                </div>
                                :
                                <div className="widget-chat">
                                    {chatContent.msg_from === chatContent.user_id ? <ul>
                                        <li className="message-own" key={chatContent.msg_id}>
                                            {/*<img src={chatContent.pers_to_photo} alt="diamond-layout"*/}
                                            {/*     title={chatContent.alıcı}/>*/}
                                            <div>
                                                {chatContent.msg_text}
                                                <p align="right"
                                                   style={{
                                                       marginTop: '3px', fontSize: '10px'
                                                   }}>{chatContent.msg_createtime}</p>
                                            </div>
                                        </li>
                                    </ul> : <ul>
                                        <li className="message-from" key={chatContent.msg_id}>
                                            {/*<img src={chatContent.pers_from_photo} alt="diamond-layout"*/}
                                            {/*     title={chatContent.gönderici}/>*/}
                                            <div>
                                                {chatContent.msg_text}
                                                <p align="right"
                                                   style={{
                                                       marginTop: '3px', fontSize: '10px'
                                                   }}>{chatContent.msg_createtime}</p>
                                            </div>
                                        </li>
                                    </ul>}

                                    {chatContent.repley_list.map((rep) => {
                                        return (<div className="widget-chat">
                                            {rep.msg_from === rep.user_id ? <ul>
                                                <li className="message-own" key={chatContent.msg_id}>
                                                    {/*<img src={chatContent.pers_to_photo} title={chatContent.alıcı}*/}
                                                    {/*     alt="diamond-layout"/>*/}
                                                    <div>
                                                        {rep.msg_text}
                                                        <p align="right" style={{
                                                            marginTop: '3px', fontSize: '10px'
                                                        }}>{rep.msg_createtime}</p>
                                                    </div>
                                                </li>
                                            </ul> : <ul>
                                                <li className="message-from" key={chatContent.msg_id}>
                                                    {/*<img src={chatContent.pers_from_photo}*/}
                                                    {/*     title={chatContent.gönderici}*/}
                                                    {/*     alt="diamond-layout"/>*/}
                                                    <div>
                                                        {rep.msg_text}
                                                        <p align="right" style={{
                                                            marginTop: '3px', fontSize: '10px'
                                                        }}>{rep.msg_createtime}</p>
                                                    </div>
                                                </li>
                                            </ul>}
                                        </div>)
                                    })}
                                </div>}

                            {user_id === ownUserID || user_id === fromUserID ?
                                <div className="new-message p-grid" ref={scroolRef}>
                                    <div className="message-input p-col-12 p-lg-11">
                                        <InputText
                                            placeholder="İletiyi Buraya Yazınız"
                                            className="p-inputtext"
                                            style={{width: '100%'}}
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            name="message"
                                            minLength={2}
                                            maxLength={500}
                                            required/>
                                    </div>
                                    <div className="message-attachment p-col-12 p-lg-1"
                                         align="right">
                                        <Button icon="pi pi-angle-right" title="Cevapla"
                                                tooltipOptions={{
                                                    position: 'bottom',
                                                    mouseTrack: true,
                                                    mouseTrackTop: 15
                                                }}
                                                onClick={() => messageMySubmit(chatContent)}
                                        />
                                    </div>
                                </div> : null}
                        </div>
                    </ScrollPanel>
                </div>
            )
        } else {
            null
        }
    }

    const chatDialogInitialize = (chat) => {
        setMsgId(chat.msg_id)
        setGetMessage(true);
        // setChatContent(chat)
        setDeleteSuccess(false)
        messageView();
    }

    const scrollbottom = () => {
        scroolRef.current &&
        scroolRef.current.scrollIntoView({behavior: "smooth", block: "start"})
    }

    const chatsTemplate = (dat) => {
        var read = dat.msg_flag_read
        var control = false
        dat.repley_list.map((rep) => {
            var msg_flag_read = rep.msg_flag_read
            var msg_to = rep.msg_to
            var user_id = rep.user_id
            if (msg_flag_read === false && msg_to === user_id) {
                control = true
            }
        })

        return (
            <div className="p-col-12 p-grid" style={{marginLeft: '20px', marginRight: '20px', marginTop: '5px'}}>
                {/*avatar*/}
                <div className="p-col-12 p-lg-2">
                    {dat.msg_send === local_user_name ?
                        <Avatar image={dat.pers_to_photo} size="large"
                                shape="circle"/>
                        :
                        <Avatar image={dat.pers_from_photo} size="large"
                                shape="circle"/>}
                </div>
                {/*names*/}
                {dat.msg_send === local_user_name ?
                    <div className="p-col-12 p-lg-8" align='left' style={{margin: 'auto'}}>
                        <span><b>{dat.msg_receive}</b></span>
                    </div> : <div className="p-col-12 p-lg-8" align='left' style={{margin: 'auto'}}>
                        {dat.msg_receive === local_user_name ? <span><b>{dat.msg_send}</b></span> : <div>
                            <span><b>{dat.msg_send}</b></span>
                            &nbsp; <i className="pi pi-arrow-right"/>&nbsp;
                            <span><b>{dat.msg_receive}</b></span>
                        </div>}
                    </div>}

                {/*button*/}
                <div className="p-col-12 p-lg-2" align="right">

                    {read === false && dat.msg_to === dat.user_id ?
                        <Tag icon="pi pi-envelope" severity="success" value="Yeni"/> : null}

                    {control
                        ? <div className="p-col-12 p-mr-4">
                            <Tag icon="pi pi-envelope" severity="success" value="Yeni"/>
                        </div>
                        : <div>
                        </div>
                    }

                    <Button icon="pi pi-angle-double-right"
                            className="p-button-rounded p-button-info p-button-text"
                            tooltip="Mesajı Görüntüle"
                            onClick={() => chatDialogInitialize(dat) & onTabOpenMessagesRead(dat)}
                            tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}/>
                </div>
            </div>
        )
    }

    const onTabOpenMessagesRead = (chat) => {
        const user_data = {
            'chat_id_list': chat.chat_id_list
        };
        const user_id = chat.user_id
        const repley_list = chat.repley_list

        if (repley_list.length === 0) {
            var last_msg_to = user_id
            var last_msg_from = chat.msg_from
        } else {
            var last_msg_to = repley_list[repley_list.length - 1].msg_to
            var last_msg_from = repley_list[repley_list.length - 1].msg_from
        }

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(user_data);
            fetch("/api/messagesRead/" + last_msg_from + "/" + last_msg_to + "/", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            // showSuccess(data.message);
                            // setData(data.result)
                        } else {
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401 || res.status === 403) {
                        setLoadingState(false);
                        throw res.data;
                    }
                })
        }
    }

    const inputMessageRecipientList = (deger) => {
        if (deger !== undefined) {
            if (deger.length >= 3) {
                messageSubmit(deger.trim())

            } else {
                setCodes([])
            }
        }
    }

    const selectedCountriesTemplate = (option) => {
        if (option) {
            return (
                <div className="country-item country-item-value">
                    <div>{option.name}</div>
                </div>
            );
        }
        return "Alıcılar";
    }


    const chatsHeader = (
        <div className="table-header p-grid">
            <div className="p-col-12 p-sm-8 p-md-8 p-lg-8">
                <h3>GÖRÜŞMELER</h3>
            </div>

            <div className="p-col-12 p-sm-4 p-md-4 p-lg-4" align='right'>
                <Button
                    tooltip="Mesaj Gönder"
                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                    icon="pi pi-plus"
                    style={{right: '0px'}}
                    className="p-button-rounded p-button-info"
                    onClick={() => {
                        setDialog(true)
                    }}/>
            </div>

        </div>
    );

    return (
        <div className="p-grid">

            <Dialog header="UYARI"
                    visible={cipDeleteDialog}
                    style={{width: '20%'}}
                    footer={renderFooter()}
                    onHide={() => setCipDeleteDialog(false)}>

                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                    <span>Silmek İstediğinizden Emin Misiniz ?</span>
                </div>
            </Dialog>

            <Card style={{width: '100%'}}>

                <div className="p-grid p-mt-3">
                    <div className="p-col-12 p-md-4" style={{whiteSpace: 'nowrap'}}>
                        <TabView>
                            <TabPanel header={all_table_header_tabpanel} leftIcon="pi pi-envelope p-mr-2">
                                <DataView
                                    header={chatsHeader}
                                    value={getmessages}
                                    layout={layoutDetail}
                                    emptyMessage="Kayıt Bulunamadı"
                                    itemTemplate={chatsTemplate}
                                    sortOrder={sortOrder}
                                    sortField={sortField}/>

                                <Paginator
                                    first={first}
                                    rows={9}
                                    totalRecords={totalRecords}
                                    onPageChange={onBasicPageChange}/>

                            </TabPanel>
                            <TabPanel header={table_header_tabpanel} leftIcon="pi pi-envelope p-mr-2">
                                <DataView
                                    header={chatsHeader}
                                    value={onlyMessages}
                                    layout={layoutDetail}
                                    emptyMessage="Kayıt Bulunamadı"
                                    itemTemplate={chatsTemplate}
                                    paginator
                                    rows={9}
                                    sortOrder={sortOrder}
                                    sortField={sortField}/>
                            </TabPanel>

                        </TabView>
                    </div>

                    <div className="p-col-12 p-md-8">
                        {messageEdit(user_id)}
                    </div>
                </div>
            </Card>

            <Dialog header="Mesaj Gönder"
                    visible={dialog}
                    breakpoints={{'960px': '75vw', '640px': '100vw'}}
                    style={{width: '58vw'}}
                    onHide={sendMessageHide}
                    dismissableMask={true}>

                <div className="p-grid">
                    <div className="p-col-12 p-md-4 p-lg-4">
                        <label htmlFor="input">Alıcı İsmi:</label>
                    </div>
                    <div className="p-col-12 p-md-8 p-lg-12">
                         <span className="p-float-label">
                             <MultiSelect value={receiverName}
                                          options={codes}
                                          style={{width: '100%'}}
                                          selectedItemsLabel="{0} kullanıcı seçildi"
                                          selectedItemTemplate={selectedCountriesTemplate}
                                          onChange={(e) => setReceiverName(e.value)}
                                          optionLabel="name"
                                          filter
                                          placeholder="Alıcılar"
                                          emptyFilterMessage="Bulunamadı"
                                          onFilter={(e => inputMessageRecipientList(e.filter))}/>
                        </span>
                    </div>
                    <div className="p-col-12 p-md-4 p-lg-4">
                        <label htmlFor="input">Mesaj Konusu:</label>
                    </div>
                    <div className="p-col-12 p-md-8 p-lg-12">
                                            <span className="p-float-label">
                                            <Dropdown style={{width: '100%'}}
                                                      inputId="dropdown"
                                                      value={messageContext}
                                                      options={typeList}
                                                      onChange={(e) => setMessageContext(e.value)}
                                                      optionLabel="name"
                                                      placeholder="Mesaj Konusu"/>
                                            </span>
                    </div>
                    <div className="p-col-12 p-md-4 p-lg-4">
                        <label htmlFor="input">Mesaj:</label>
                    </div>
                    <div className="p-col-12 p-md-8 p-lg-12">

                        <InputTextarea value={message}
                                       onChange={(e) => setMessage(e.target.value)}
                                       rows={5}
                                       cols={30}
                                       required
                                       style={{width: '100%', height: '12em'}}/>
                    </div>
                </div>
                <hr></hr>
                <div className="p-col-12 p-md-12 p-card" align="right">
                    <Button
                        label="Gönder"
                        type=" submit"
                        icon=" pi pi-save"
                        onClick={submit}/>

                    <Button
                        label=" Vazgeç"
                        className=" p-button-secondary"
                        style={{marginLeft: '5px'}}
                        type=" button"
                        onClick={() => setDialog(false)}
                        icon=" pi pi-times"/>
                </div>
            </Dialog>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        user: state.auth.user, management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        }, postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        }, deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        }, logout: () => dispatch(auth.logout()), loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageList);



// WEBPACK FOOTER //
// ./src/pages/messageManagement/MessageList.jsx